




import {Component, Prop, Vue} from 'vue-property-decorator';
import ConfirmModal from "@/components/ConfirmModal.vue";

@Component({
    components: {ConfirmModal},
    name: "CompanyWorker",
})
export default class Starred extends Vue {
    @Prop(Boolean) private readonly starred!: boolean;
    @Prop(String) private readonly msg!: string;
    @Prop({type:Boolean,default:false}) private readonly inverted!: string;

    private handleClick() {
        if(this.starred){
            this.$bvModal.msgBoxConfirm(this.msg || 'Sei sicuro?',{
                okTitle: 'Sì',
                cancelTitle: 'No',
                footerClass: 'justify-content-between',
            })
                .then(value => {
                    if(value){
                        this.resolve()
                    } else {
                        this.reject()
                    }
                })
                .catch(err => {
                })
        } else {
            this.resolve()
        }
    }

    private resolve() {
        this.$emit('si')
    }

    private reject() {
        this.$emit('no')
    }
}

